import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@app/components/components.module';
import { EaSimulationPacksComponent } from './ea-simulation-packs.component';
import { SimulationPackTableComponent } from './simulation-pack-table/simulation-pack-table.component';
import { SimulationPackComponent } from './simulation-packs/simulation-pack/simulation-pack.component';
import { SimulationPacksComponent } from './simulation-packs/simulation-packs.component';
import { SimulationPackService } from './simulation-pack.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

const COMPONENTS = [
  EaSimulationPacksComponent,
  SimulationPacksComponent,
  SimulationPackComponent,
  SimulationPackTableComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, ComponentsModule, TooltipModule],
  exports: [...COMPONENTS],
})
export class EaSimulationPacksModule {}
